import React from 'react';
import { motion } from 'framer-motion';

const NauticalGridBackground: React.FC = () => {
  const draw = {
    hidden: { pathLength: 0, opacity: 0 },
    visible: {
      pathLength: 1,
      opacity: 1,
      transition: {
        pathLength: { type: "spring", duration: 3, bounce: 0 },
        opacity: { duration: 0.01 }
      }
    }
  };

  return (
    <div className="absolute inset-0 overflow-hidden pointer-events-none">
      <motion.svg
        width="100%"
        height="100%"
        viewBox="0 0 1000 1000"
        initial="hidden"
        animate="visible"
        className="absolute inset-0"
        style={{
          opacity: 0.05, // Low opacity as requested
          stroke: 'hsl(var(--gold))', // Gold lines
          strokeWidth: '1',
        }}
      >
        {/* Horizontal lines */}
        {[...Array(20)].map((_, i) => (
          <motion.line
            key={`h-line-${i}`}
            x1="0"
            y1={i * 50}
            x2="1000"
            y2={i * 50}
            variants={draw}
            custom={i + 1}
          />
        ))}
        {/* Vertical lines */}
        {[...Array(20)].map((_, i) => (
          <motion.line
            key={`v-line-${i}`}
            x1={i * 50}
            y1="0"
            x2={i * 50}
            y2="1000"
            variants={draw}
            custom={i + 21}
          />
        ))}
      </motion.svg>
    </div>
  );
};

export default NauticalGridBackground;